import React, { useState, Fragment, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import style from "./AccessConfiguration.scss";
import { Contract } from "./Contract/Contract";
import { AccessConfigurationGrid } from "./AccessConfigurationGrid/AccessConfigurationGrid";
import { AccessConfigurationAccount } from "./AccessConfigurationAccount/AccessConfigurationAccount";
import { Confirmation } from "./Confirmation/Confirmation";
import { Suitability } from "./Suitability/Suitability";

export const AccessConfiguration = ({ approved, handleAuthorize }) => {
  const [tab, setTab] = useState(approved ? "confirmation" : "data");
  const [contractId, setContractId] = useState(0);
  const [vpWidth, setVPWidth] = useState({width: window.innerWidth});

  const toggle = (toggleString, newContractId) => {
    if (toggleString === "confirmation") {
      handleAuthorize(contractId);
    }
    if (newContractId) {
      setContractId(newContractId);
    }
    setTab(toggleString);
  };

  return (
    <div className={style.body}>
      <Fragment>
        <Title currentTab={tab} />
        <Row className={style.buttonContainer}>
          <Col className={style.col} xs={3} sm={3} md={3} lg={2} xl={2} xxl={2}>
            <CustomButton currentTab={tab} name={"data"} label={vpWidth.width > 576 ? "01. datos" : tab === "data" ? "01. datos" : "01."} onClick={toggle} />
          </Col>
          <Col className={style.col} xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
            <CustomButton currentTab={tab} name={"contract"} label={vpWidth.width > 576 ? "02. contrato" : tab === "contract" ? "02. contrato" : "02."} onClick={toggle} />
          </Col>
          <Col className={style.col} xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
            <CustomButton currentTab={tab} name={"account"} label={ vpWidth.width > 576 ? "03. cuentas" : tab === "account" ? "03. cuentas" : "03."} onClick={toggle} />
          </Col>
          <Col className={style.col} xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
            <CustomButton currentTab={tab} name={"suitability"} label={vpWidth.width > 576 ? "04. Perfil del Inversor" :  tab === "questions" ? "04. Perfil del Inversor" : "04."} onClick={toggle} />
          </Col>
          <Col className={style.col} xs={3} sm={3} md={3} lg={2} xl={2} xxl={2}>
            <CustomButton currentTab={tab} name={"confirmation"} label={vpWidth.width > 576 ? "05. confirmación" : tab === "confirmation" ? "05. confirmación" : "05."} onClick={toggle} />
          </Col>
        </Row>
        <ActiveTab currentTab={tab} toggle={toggle} />
      </Fragment>
    </div>
  );
};

const CustomButton = ({ currentTab, name, label, onClick }) => {
  const disabled = currentTab !== name;
  return (
    <Button
      className={!disabled ? style.buttonActive : style.buttonDisabled}
      onClick={() => {
        currentTab !== name ? onClick(currentTab) : null;
      }}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

const ActiveTab = ({ currentTab, toggle }) => {
  switch (currentTab) {
    case "data":
      return <AccessConfigurationGrid toggle={toggle} />;
    case "contract":
      return <Contract toggle={toggle} />;
    case "account":
      return <AccessConfigurationAccount toggle={toggle} />;
    case "suitability":
      return <Suitability toggle={toggle} />;
    case "confirmation":
      return <Confirmation toggle={toggle} />;
    default:
      return null;
  }
};

const Title = ({ currentTab }) => {
  switch (currentTab) {
    case "data":
      return <p className={style.title}>Configuración de acceso</p>;
    case "contract":
      return <p className={style.title}>Configuración de acceso / Contrato</p>;
    case "account":
      return <p className={style.title}>Configuración de acceso / Cuentas</p>;
    case "suitability":
      return <p className={style.title}>Configuración de acceso / Suitability</p>;
    case "confirmation":
      return <p className={style.title}>Configuración de acceso / Confirmación</p>;
    default:
      return null;
  }
};
